import {
  Box,
  Dialog,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { generateClient } from 'aws-amplify/api';

import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import { Schema } from '../../../../amplify/data/resource';
import SendButton from '../../../components/custom/SendButton';

const apiClient = generateClient<Schema>();

const File = ({
  open,
  onClose,
  setSelectedFile,
}: {
  open: boolean;
  onClose: () => void;
  setSelectedFile: (file: File) => void;
}) => {
  const theme = useTheme();

  const [file, setFile] = useState<File | null>(null);
  const [isReplace, setIsReplace] = useState(false);
  const [replace, setReplace] = useState(false);

  const inputRef = useRef<HTMLInputElement | null>(null);
  const uploadFileRef = useRef<HTMLDivElement | null>(null);

  const handleBoxClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsReplace(false);
    setReplace(false);
    const uploadedFile = event.target.files?.[0];
    if (uploadedFile) {
      setFile(uploadedFile);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files?.[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };

  const resetComponent = () => {
    setFile(null);
    setIsReplace(false);
    setReplace(false);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
    console.log('Component state has been reset.');
  };

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '35px',
        },
      }}
    >
      <Stack
        spacing={4}
        sx={{
          width: '500px',
          background: '#3A3A3A',
          '& .MuiDialog-paper': {
            background: '#3A3A3A',
            padding: '60px',
            boxSizing: 'border-box',
            position: 'relative',
            overflow: 'hidden',
          },
          px: '40px',
          py: '35px',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            zIndex: 1,
          }}
        >
          <img
            alt="close"
            src={'/assets/client/close-white.svg'}
            width="15"
            height="15"
            style={{ cursor: 'pointer' }}
          />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '318px',
            backgroundColor: '#0000008A',
            borderRadius: '15px',
            cursor: 'pointer',
          }}
          onClick={handleBoxClick}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              alignItems: 'center',
            }}
          >
            <img src="/assets/uploadFile/coins.svg" alt="Upload" />
            <Typography
              sx={{ color: '#FFF' }}
              fontSize={'12px'}
              fontWeight={'700'}
            >
              לחץ כאן או גרור את הקובץ
            </Typography>
          </Box>
          <input
            type="file"
            accept=".dat"
            ref={inputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </Box>
        {file && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row-reverse',
              gap: '10px',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                backgroundColor: '#00000042',
                py: '5px',
                px: '15px',
                display: 'flex',
                gap: '5px',
                alignItems: 'center',
                borderRadius: '30px',
                width: '100%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#FFF'}
              >
                {file.name}
              </Typography>
              <Icon
                style={{ cursor: 'pointer' }}
                icon={'material-symbols:close'}
                color="#FFF"
                onClick={() => setFile(null)}
              />
            </Box>
          </Box>
        )}
        {file && (
          <SendButton
            loading={false}
            label="העלאת קובץ"
            onClick={() => {
              setSelectedFile(file);
              onClose();
            }}
          />
        )}
      </Stack>
    </Dialog>
  );
};

export default File;
